(function () {
  'use strict';

  function init(wurzel) {
    var form = wurzel.querySelector('#nh-form');
    var fertig = wurzel.querySelector('[data-nh-fertig]');
    if (fertig) { fertig.focus(); return; }
    if (!form) return;

    var t = {};
    try { t = JSON.parse(wurzel.querySelector('[data-nh-i18n]').textContent); } catch (e) {}

    var suche = wurzel.querySelector('[data-nh-suche]');
    var leiste = wurzel.querySelector('[data-nh-leiste]');
    var eingabe = wurzel.querySelector('[data-nh-eingabe]');
    var liste = wurzel.querySelector('[data-nh-liste]');
    var gewaehlt = wurzel.querySelector('[data-nh-gewaehlt]');
    var gewName = wurzel.querySelector('[data-nh-gew-n]');
    var tagsFeld = wurzel.querySelector('[data-nh-tags]');
    var wahl = null;
    var treffer = [];
    var aktiv = -1;
    var uhr = null;
    var anfrage = 0;
    var proxy = (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db';

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function zoll(m) {
      var z = m.size_inch ? String(m.size_inch).replace('.', t.komma || ',') + '″' : '';
      return z + (m.year ? (z ? ' · ' : '') + m.year : '');
    }
    function slug(s) {
      return String(s).toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    }

    function zu() {
      liste.hidden = true;
      liste.innerHTML = '';
      eingabe.setAttribute('aria-expanded', 'false');
      aktiv = -1;
    }
    function auf(html) {
      liste.innerHTML = html;
      liste.hidden = false;
      eingabe.setAttribute('aria-expanded', 'true');
      aktiv = -1;
      if (window.Suchebene && window.Suchebene.messen) window.Suchebene.messen();
    }
    function freiZeile(q) {
      return '<button type="button" class="nh__frei" data-frei="1" role="option"><span>' +
        (t.frei || '').replace('%s', '<b>„' + esc(q) + '“</b>') + '</span></button>';
    }

    function suchen(q) {
      var nr = ++anfrage;
      var url = proxy + '/monitors/search?q=' + encodeURIComponent(q);
      var hol = window.EngineStatus ? window.EngineStatus.hol(url) : fetch(url).then(function (r) { return r.json(); });
      hol.then(function (d) {
        if (nr !== anfrage) return;
        treffer = (d && d.data && d.data.results) ? d.data.results.slice(0, 8) : [];
        var html = treffer.map(function (m, i) {
          return '<button type="button" role="option" data-i="' + i + '"><span>' + esc(m.name) + '</span><small>' + esc(zoll(m)) + '</small></button>';
        }).join('');
        if (!treffer.length) html = '<p>' + esc(t.keine || '') + '</p>';
        auf(html + freiZeile(q));
      }).catch(function () {
        if (nr !== anfrage) return;
        treffer = [];
        auf('<p>' + esc(t.suche_aus || '') + '</p>' + freiZeile(q));
      });
    }

    function waehle(m, frei) {
      wahl = frei ? { frei: true, name: m } : { frei: false, ref: m.ref, name: m.name };
      gewName.innerHTML = esc(wahl.name) + '<small>' + esc(frei ? (t.frei_gewaehlt || '') : zoll(m)) + '</small>';
      if (window.Suchebene && window.Suchebene.zu) window.Suchebene.zu();
      zu();
      suche.hidden = true;
      gewaehlt.hidden = false;
    }
    function zuruecksetzen() {
      wahl = null;
      eingabe.value = '';
      suche.hidden = false;
      gewaehlt.hidden = true;
    }

    eingabe.addEventListener('input', function () {
      var q = eingabe.value.trim();
      clearTimeout(uhr);
      if (q.length < 2) { zu(); return; }
      uhr = setTimeout(function () { suchen(q); }, 180);
    });
    eingabe.addEventListener('keydown', function (e) {
      var knoepfe = liste.querySelectorAll('button');
      if (e.key === 'Enter') {
        e.preventDefault();
        if (aktiv >= 0 && knoepfe[aktiv]) knoepfe[aktiv].click();
        return;
      }
      if (liste.hidden || !knoepfe.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        aktiv = (aktiv + (e.key === 'ArrowDown' ? 1 : -1) + knoepfe.length) % knoepfe.length;
        knoepfe.forEach(function (k, i) { k.setAttribute('aria-selected', i === aktiv ? 'true' : 'false'); });
      }
      if (e.key === 'Escape') zu();
    });
    liste.addEventListener('click', function (e) {
      var k = e.target.closest('button');
      if (!k) return;
      if (k.getAttribute('data-frei')) waehle(eingabe.value.trim(), true);
      else waehle(treffer[+k.getAttribute('data-i')], false);
    });
    document.addEventListener('click', function (e) {
      if (!suche.contains(e.target) && !liste.contains(e.target)) zu();
    });
    wurzel.querySelector('[data-nh-aendern]').addEventListener('click', function () {
      zuruecksetzen();
      eingabe.focus();
    });

    if (window.Suchebene && leiste) {
      window.Suchebene.binden({ leiste: leiste, eingabe: eingabe, liste: liste, zu: zu, titel: t.ebene });
    }

    form.addEventListener('submit', function () {
      var tags = ['newsletter', 'neuheiten-seite'];
      wurzel.querySelectorAll('[data-nh-interesse]:checked').forEach(function (c) { tags.push('interesse-' + c.value); });
      if (wahl && !wahl.frei) tags.push('monitor-' + wahl.ref, 'modell-' + slug(wahl.name));
      if (wahl && wahl.frei && slug(wahl.name)) tags.push('monitor-frei', 'modell-' + slug(wahl.name));
      tagsFeld.value = tags.join(',');
    });
  }

  function start() { document.querySelectorAll('[data-nh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
